import React, {Component} from 'react';
import { 
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe } from 'react-stripe-elements'

  var $ = require('jquery');

class StripeCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
      clearStripe: false,
    }
  }



  stripePay = async (ev) => {
    try {
        ev.preventDefault()
        this.props.setSpinner()
      let totalOnSubmit = this.props.pricingBreakdown.total
      console.log(totalOnSubmit, "before round")
      console.log(Math.round((totalOnSubmit) * 100), "stripe submit")
      console.log(this.props.currencyType, "CURRENCY TYPE")
       let {token} = await this.props.stripe.createToken({email: this.props.email}, {stripe_account: this.props.account});
      console.log("string in, HERE")
      let response =  $.ajax({
        type: 'POST',
        data: JSON.stringify({
          "token" : token,
          "email": this.props.email,
          "charge": {
            "amount": Math.round((totalOnSubmit) * 100), //(Number(this.props.cost) * 100),
            "currency": this.props.currencyType,
          },
        }),
        // headers: {
        //     "token": this.state.token,
        //     "organization_id": this.state.organization_id
        // },
        contentType: 'application/json',
        method: "POST",
        url: `${this.props.stripeEndPoint}`,
        success: (results) => {
          console.log(results, "results?")
          this.props.patchReceipt(response.responseJSON.id, results);
   
          console.log("RESPONSE JSON",response, response._id)
          //send recipt
          // rthis.setState({ convergeToken: results })
          console.log("SUCCESS")

        },
        error: (error) => {
          this.props.stripeDecline()
          this._element.clear()
          this._element1.clear()
          this._element2.clear()
          console.log(error, "error")
        }
    })
      console.log(response, "CHECK FOR AND TRANSCATION ID, ERROR, DECLINED, APPROVAL")

      if ((response.status === 200)) (alert("Purchase Complete"))
    
    } catch (err) {

      console.log(err, "stripe charge")

    }
  }

  
  render() {
    const stripeStyles =  {
          base: {
            color: '#1f2430',
            fontFamily: 'Montserrat, Arial, sans-serif',
            '::placeholder': {
              color: "#94a3b8",
            },
            marginTop: '5px'
          },
    };

    return (
      <div className="checkout" style={{ display: 'flex', flexDirection: 'column', gap: '14px', width: '100%' }}>
        <div className="form-group">
          <label className="control-label">Credit Card Number</label>
          <CardNumberElement 
          onReady={(element) => this._element = element}
          className="opaque-grey form-control enrolment-payment-input" 
          style={stripeStyles}/>
        </div>
        <div className="enrolment-payment-grid">
          <div className="form-group">
            <label className="control-label">Expiry Date</label>
            <CardExpiryElement 
            onReady={(element) => this._element1 = element}
            className="opaque-grey form-control enrolment-payment-input"
            style={stripeStyles}/>
          </div>
          <div className="form-group">
            <label className="control-label">CVV</label>
            <CardCVCElement 
            onReady={(element) => this._element2 = element}
            className="opaque-grey form-control enrolment-payment-input"
            style={stripeStyles}/>
          </div>
        </div>
        <div className="enrolment-payment-preview-input-group" style={{alignItems: 'end'}}>
          <div className="form-group">
            <label className="control-label">&nbsp;</label>
            {
              this.props.pay_spinner ? <div className="enrolment-loader"></div> :
                <button
                className="orange-fill pay-button btn btn-default enrolment-payment-preview-button"
                onClick={this.stripePay}
                style={{ padding: '0', height: '42px'}}>Pay Now</button>
            }
          </div>
          <div className="card-brand-row" style={{ justifyContent: 'flex-end' }}>
            <img src="Visa5.png" alt="visa-option" />
            <img src="Mastercard5.png" alt="mastercard-option" />
            <img src="Discover4.png" alt="discover-option" />
            <img src="Unionpay4.png" alt="unionpay-option" />
          </div>
        </div><br/><br/><br/>
      </div>
    );
  }
}

export default injectStripe(StripeCheckout);
